export default __webpack_public_path__ + "static/media/life-insurance-benefit.0bccd3e5.png";